{
  "aboutProject": "Om prosjektet",
  "attachmentComment": "Kommentar til vedlegget",
  "attachmentName": "Navn på vedlegget",
  "buisinessDescription": "Virksomhetsbeskrivelse",
  "cannotChangeFinishedProject": "Kan ikke endre et avsluttet prosjekt.",
  "cantGetProjectTypes": "Klarte ikke hente prosjekttyper, last inn siden på nytt og prøv igjen",
  "causeOfProjectEnd": "Årsak til avslutning",
  "changeMainGoal": "Endre hovedmål",
  "changeMainGoalDescription": "Dere må forklare hvorfor dere ønsker å endre hovedmålet til dette prosjektet. Dette blir lagt inn i klyngens årsrapport.",
  "changeMainGoalWhy": "Hvorfor har dere endret hovedmål?",
  "changeProjectType": "Endre prosjekttype",
  "changeType": "Endre type",
  "changingMainGoal": "Endring av hovedmål",
  "changingTypeDeletesBudget": "Endring av prosjekttype vil slette all budsjettdata. Det vil komme nye kostnadstyper som må fylles inn. Dette valget kan ikke angres.",
  "chooseCause": "Velg årsak",
  "chooseMultiple": "(du kan velge flere)",
  "chooseMultipleFocusAreas": "(du kan velge flere fokusområder)",
  "chooseProgression": "Velg videreføring",
  "clickHereToGo": "Klikk her for å gå til",
  "couldNotAddLeadToProject": "Kunne ikke legge til lead til prosjektet.",
  "couldNotCreateCategory": "Kunne ikke opprette ny prosjektkategori. Prøv igjen.",
  "couldNotCreateProject": "Kunne ikke opprette prosjekt. Fiks eventuelle feil og prøv på nytt.",
  "couldNotDeleteProject": "Kunne ikke slette prosjekt, vennligst prøv igjen.",
  "couldNotEditActivity": "Kunne ikke redigere aktivitet. Vennligst prøv igjen.",
  "couldNotEndProject": "Kunne ikke avslutte prosjekt. Vennligst prøv igjen.",
  "couldNotUpdateProject": "Kunne ikke oppdatere prosjektet. Vennligst prøv igjen.",
  "createActivity": "Opprett aktivitet",
  "createProjectError": "En feil oppstod ved forsøk på å opprette prosjekt. Sjekk at alle felter validerer og at ny prosjektkategori ikke har samme navn som en som allerede eksisterer.",
  "customCategories": "Egendefinerte kategorier",
  "customProjectCategoryName": "Navn på ny prosjektkategori",
  "deleteProject": "Slett prosjekt",
  "developmentProjects": "Utviklingsprosjekter",
  "editActivity": "Rediger aktivitet",
  "educationalOfferingsDescriptionLabel": "Prosjektets innhold",
  "ended": "Avsluttet",
  "endProject": "Avslutt prosjekt",
  "errorCode.Between1And5WhenEndCategoryIsCompleted": "Fornøydhetsgrad må være mellom 1 og 5 når sluttkategori er 'fullført'",
  "errorCode.CannotSetEndReasonWhenNotTerminated": "Kan ikke sette sluttårsak når prosjektet ikke er avsluttet",
  "errorCode.CategoryRequiredWhenNoType": "Prosjektkategori må fylles ut når type ikke er valgt",
  "errorCode.EndSubCategoryOnlySetWhenContinued": "Underkategori for sluttårsak skal kun velges når hovedkategori er 'videreført'",
  "errorCode.EndSubCategoryRequiredWhenContinued": "Underkategori for sluttårsak må velges når hovedkategori er 'videreført'",
  "errorCode.SatisfactionRateShouldOnlyBeSetWhenCompleted": "Fornøydhetsgrad skal kun settes når sluttkategori er 'fullført'",
  "errorCode.SourceCodeMustBeApplicationCrmOrPortal": "Prosjektkilde må være 'Application', 'CRM' eller 'Portal'",
  "explainProjectProgression": "Forklar hva prosjektet ble videreført til",
  "focusAreas": "Fokusområder",
  "goalDescriptionLabel": "Forventede resultater og effektmål",
  "goToProjects": "Gå til prosjekter",
  "inFinancedProjects": "prosjekter finansiert av Innovasjon Norge",
  "inFinancedProjectsDescription": "Her ser dere prosjekter finansiert av Innovasjon Norge, disse er hentet fra søknad.",
  "justificationLabel": "Bakgrunn",
  "mainGoal": "Hovedmål",
  "missingProjectCategory": "Ved valg av prosjektkategori Annet må det skrives inn navn på prosjektkategori.",
  "missingStartOrEndDate": "Prosjektet mangler gyldig start eller sluttdato.",
  "mission": "Misjon",
  "newActivity": "Ny aktivitet",
  "noInFinancedProjects": "Dere har ingen prosjekter finansiert av Innovasjon Norge. Prosjekter dere søker om i søknaden vil vises her.",
  "noneSelected.removeParticipant": "Du må markere minst en rad for å kunne fjerne deltagere.",
  "noOwnProjects": "Dere har ingen egne prosjekter, disse kan opprettes i portalen.",
  "numberOfEvents": "Antall eventer",
  "onlyChooseOne": "(du kan kun velge ett klyngemål)",
  "otherProjects": "Andre prosjekter",
  "ownProjects": "egne prosjekter",
  "PEC01": "Avbrutt",
  "PEC02": "Gjennomført",
  "PEC03": "Videreført",
  "portalProjectsDescription": "Her ser dere prosjekter som er opprettet i portalen.",
  "predefinedCategories": "Predefinerte kategorier",
  "project": "Prosjekt",
  "projectCategories": "Prosjektkategorier",
  "projectCategoryAlreadyExists": "Ny prosjektkategori eksisterer allerede med dette navnet.",
  "projectDeleteWarning": "Er du helt sikker på at dette prosjektet skal slettes? Alle opprettede eventer og tilhørende egeninnsats vil bli slettet.",
  "projectDescription": "Prosjektbeskrivelse",
  "projectLeader": "Prosjektleder",
  "projectMissingType": "Dette prosjektet mangler prosjekttype",
  "projectName": "Prosjektnavn",
  "projects": "Prosjekter",
  "projectsDescription": "Prosjektene som registreres kan være i regi av klyngen eller klyngens medlemmer. Hensikten med å registrere prosjektene som gjennomføres i klyngen er å gi klyngeledelsen en oversikt over aktiviteten som foregår i klyngen.",
  "projectsPerPage": "Prosjekter per side",
  "projectType": "Prosjekttype",
  "rateProjectSuccess": "I hvilken grad vil du vurdere prosjektet som vellykket?",
  "registeredHours": "Registrerte timer",
  "searchMainGoal": "Søk hovedmål",
  "searchSubProject": "Søk delprosjekt",
  "seeINProjects": "For å se prosjekter finansiert av IN gå til",
  "seeOtherProjects": "For å se øvrige prosjekter kan dere gå til oversikt over",
  "selectFocusAreas": "Velg fokusområder",
  "selectGoal": "Velg mål",
  "selectProject": "Velg prosjekt",
  "selectProjectCategory": "Velg prosjektkategori",
  "selectSocietalAndEnvironmentalEffects": "Velg sammfuns- og miljøeffekt",
  "selectType": "Velg type",
  "societalAndEnvironmentalEffects": "Samfunns- og miljøeffekter",
  "subproject": "Delprosjekt",
  "subProjects": "Delprosjekter",
  "toAGreatExtent": "I stor grad",
  "toASmallExtent": "I liten grad",
  "trainingDescriptionLabel": "Opplæringsprosjektets innhold",
  "typeChangedTo": "Type er nå endret til {{newType}}",
  "uniqueParticipants": "Unike deltagere",
  "vision": "Visjon",
  "visionAndMission": "Visjon & misjon",
  "whatWasProjectProgressedTo": "Hva ble prosjektet videreført til?",
  "whatWasResultOfProject": "Hva ble resultatet av prosjektet?",
  "whyProjectedEnded": "Hvorfor ble prosjektet avsluttet?",
  "noCompaniesSelected": "Ingen bedrifter valgt"
}
